import {
  GET_SELLERS_ATTEMPT,
  GET_SELLERS_SUCCESS,
  GET_SELLERS_FAILURE,
} from "../constants";

import { SellersInitialState } from "../../types/sellers";

const initialState: SellersInitialState = {
  fetchingSellersList: 0,
  errorMessage: "",
  success: true,
  sellersList: [],
};

export default (state = initialState, action: any) => {
  switch (action.type) {
    // getSellers
    case GET_SELLERS_ATTEMPT:
      return {
        ...state,
        fetchingSellersList: state.fetchingSellersList + 1,
        success: true,
        errorMessage: "",
      };
    case GET_SELLERS_SUCCESS:
      return {
        ...state,
        fetchingSellersList: state.fetchingSellersList - 1,
        success: true,
        errorMessage: "",
        sellersList: validData(action.payload.data),
      };
    case GET_SELLERS_FAILURE:
      return {
        ...state,
        fetchingSellersList: state.fetchingSellersList - 1,
        success: false,
        errorMessage: action.payload.error,
      };

    default:
      return state;
  }
};

function validData (data: any[]) {
  return data.filter((element: any) => element.sellerId)
}